<script>
	import {
		Modal,
		ModalBody,
		ModalHeader,
		ModalFooter,
	} from "@sveltestrap/sveltestrap";
	import CustomButton from "../CustomButton/CustomButton.svelte";
	import { csvErrorData } from "src/store/store";
	import CsvErrorTable from "./CsvErrorTable.svelte";
	import ErrorBanner from "../ErrorBanner/ErrorBanner.svelte";

	export let open = false;
	export let toggle;
	export let err;
	export let header;
	export let bodyText;
	export let buttonText;

	let errors;
	csvErrorData.subscribe((value) => {
		errors = value;
	});
</script>

<Modal isOpen={open} backdrop centered {toggle} size="xl">
	<ModalHeader {toggle}>
		<b>
			{"Upload Error"}
		</b>
	</ModalHeader>
	<ModalBody>
		<ErrorBanner
			errorHeader="Invalid Data Formatting"
			errorText="There are some errors found in your data. Resolve the following errors and try to re-upload again."
		/>
		<CsvErrorTable {errors} />
	</ModalBody>
	<ModalFooter>
		<CustomButton buttonText="OK" on:click={toggle} />
	</ModalFooter>
</Modal>
